
export default {
  computed: {
    $mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  }
}



// WEBPACK FOOTER //
// ./src/globals/mobile.js